import script from "./StageFour.vue?vue&type=script&setup=true&lang=js"
export * from "./StageFour.vue?vue&type=script&setup=true&lang=js"

import "./StageFour.vue?vue&type=style&index=0&id=9bfb2bee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bfb2bee"]])

export default __exports__